<template>
    <div class="checkout relative">
    <VivaLoader />
    <HeaderDashboard />
        <main class="checkout-component bg-gray-50 pt-16 md:pt-36 pb-10">
            <div class="mx-auto flex flex-col md:flex-row max-w-7xl container">
                <DashboardSidebarMenu isPage="pagos" class="hidden md:block"/>
                <div class="main-content w-full md:w-4/5 flex flex-col">
                    <section class="mb-5">
                        <div class="max-w-6xl mx-auto px-4">
                        <DashboardUserCardInformation />
                        </div>
                    </section>
                    <section class="mb-0">
                        <div class="max-w-6xl mx-auto px-4">
                            <div class="flex flex-col lg:flex-row justify-between w-full lg:space-x-6 items-start">
                                <div class="w-full lg:w-1/2 "> 
                                    <div class="box w-full flex flex-col justify-between p-6 mb-5 lg:mb-0">
                                        <h3 class="section-header text-2xl text-green-500 font-semibold md:font-bold mb-5">
                                            {{dashboardTranslate[language].card.payment.title}}
                                        </h3>
                                        <div class="flex justify-between pb-3" v-if="subscription">
                                            <div class="w-2/3 pr-2">
                                                <p class="text-gray-300 text-sm">{{dashboardTranslate[language].card.payment.cardNumber}}</p>
                                                <div class="flex mt-3">
                                                    <img src="@/assets/img/cc/mastercard.svg" width="50" v-if="subscription.billing.cardDetails.cardType == 'Mastercard' "/>
                                                    <img src="@/assets/img/cc/amex.svg" width="50" v-if="subscription.billing.cardDetails.cardType == 'Amex' "/>
                                                    <img src="@/assets/img/cc/visa.svg" width="50" v-if="subscription.billing.cardDetails.cardType == 'Visa' "/>

                                                    <p class="text-green-500 font-semibold ml-3 "> &middot; &middot; &middot; {{subscription.billing.cardDetails.lastFourDigits}} </p>
                                                </div>
                                            </div>
                                            <div class="w-2/4 ">
                                                <p class="text-gray-300 text-sm">{{dashboardTranslate[language].card.payment.expiration}}</p>
                                                <div class="flex items-center justify-between pr-5 mt-3">
                                                    <p class=" text-green-500 font-semibold  ">
                                                        {{subscription.billing.cardDetails.expirationMonth}}/{{ subscription.billing.cardDetails.expirationYear}} </p>
                                                        <a @click.prevent="goToLink('DashboardPagoEdit')" class="cursor-pointer">  <FontAwesomeIcon :icon="faEdit" /> </a>
                                                </div>
                                            </div>
                                        </div>
                                       
                                    </div>
                                    <div class="box w-full flex flex-col justify-between p-6 mb-5 lg:mb-0 mt-5 " >
                                        <h3 class="section-header text-2xl text-green-500 font-semibold md:font-bold mb-5">
                                            {{dashboardTranslate[language].billing.title }}
                                        </h3>

                                         <Notification
                                            type="error"
                                            :title="`<strong> ${notificationTranslate[language][fracturacionError.code].title}</strong>
                                                    <span class='font-light'> ${notificationTranslate[language][fracturacionError.code].content}</span>`"
                                            v-if="Object.keys(fracturacionError).length > 0"
                                            />
                                        <Notification
                                            type="success"
                                            :title="`<strong> ${dashboardTranslate[language].billing.successTitle} </strong>
                                                    <div class='font-light'> ${dashboardTranslate[language].billing.successDescription}</div>`"
                                            v-if="fracturacionSuccess"
                                            />

                                        <div class=" py-5 flex flex-wrap" v-show="!isEditFacturacion" v-if="subscription?.billing.fiscals != null">
                                            <div class="w-full px-4 my-2">
                                                <div class="text-green-500 opacity-50 w-full top-5 left-5 pl-1 text-xs font-thin">
                                                {{ dashboardTranslate[language].billing.name }}   
 
                                                </div>
                                                <div class="font-bold px-1">
                                                    {{ subscription?.billing.fiscals[0]?.bussinessName }} 
                                                </div>
                                            </div>
                                            <div class="w-full px-4 my-2">
                                                <div class="text-green-500 opacity-50 w-full top-5 left-5 pl-1 text-xs font-thin">
                                                    RFC 
                                                </div>
                                                <div class="font-bold px-1">   {{ subscription?.billing.fiscals[0]?.rfc }}  </div>
                                            </div>
                                            <div class="md:w-6/12 sm:w-full px-4 my-2">
                                                <div class="text-green-500 opacity-50 w-full top-5 left-5 pl-1 text-xs font-thin">
                                                    {{ dashboardTranslate[language].billing.card }}   
 
                                                </div>
                                                <div class="font-bold px-1">
                                                    {{ getPaymentCodeDescription(  subscription?.billing.fiscals[0]?.paymentCode ) }}
                                                </div>
                                            </div>
                                             <div class="md:w-6/12 sm:w-full xs:w-full px-4 my-2">
                                                <div class="text-green-500 opacity-50 w-full top-5 left-5 pl-1 text-xs font-thin">
                                                     {{ dashboardTranslate[language].billing.clave }}   
                                                </div>
                                                <div class="font-bold px-1"> 

                                                    {{ getCFDIUseDescription( subscription?.billing.fiscals[0]?.cfdiUse ) }}  </div>
                                            </div>
                                            <div class="md:w-6/12 sm:w-full xs:w-full px-4 my-2">
                                                <div class="text-green-500 opacity-50 w-full top-5 left-5 pl-1 text-xs font-thin">
                                                    {{ dashboardTranslate[language].billing.zipCode }} 
                                                </div>
                                                <div class="font-bold px-1"> {{ subscription?.billing.fiscals[0]?.zipCode }} </div>
                                            </div>
                                            

                                             <div class="md:full sm:w-full xs:w-full px-4 my-2">
                                                <div class="text-green-500 opacity-50 w-full top-5 left-5 pl-1 text-xs font-thin">
                                                     {{ dashboardTranslate[language].billing.regimen }}   
                                                </div>
                                                <div class="font-bold px-1"> {{ getRegimenCodeDescription(  subscription?.billing.fiscals[0]?.regimenCode ) }}</div>
                                            </div>
                                            <div class="flex items-end justify-end w-full  pt-5 px-5 border-t mx-5 mt-10">
                                                <button class="font-bold " @click.prevent="isEditFacturacion = !isEditFacturacion"> {{dashboardTranslate[language].billing.edit }}    
                                                    <FontAwesomeIcon :icon="faArrowRight" class="ml-3"/>
                                                </button>
                                            </div>
                                        </div>
                                        <div>
                                            <div class="flex w-full  pt-5 mt-10" v-if="subscription?.billing.fiscals == null" v-show="isEditFacturacion == false">
                                                <p> {{dashboardTranslate[language].billing.empty }} </p>
                                            </div>
                                            <div class="flex items-end justify-end w-full  pt-5 px-5 border-t mt-10" v-if="subscription?.billing.fiscals == null" v-show="isEditFacturacion == false">
                                                <button class="font-bold " @click.prevent="isEditFacturacion = !isEditFacturacion"> 
                                                    {{dashboardTranslate[language].billing.add }}  
                                                    <FontAwesomeIcon :icon="faArrowRight" class="ml-3"/>
                                                </button>
                                            </div>
                                        </div>
                                        <form class="relative py-2" v-show="isEditFacturacion" @submit.prevent="onSubmit">
                                            <label for="name" class="px-4 pt-3 top-0 text-sm font-medium flex items-center relative flex-wrap">
                                                <span class="text-green-500 opacity-50 w-full absolute top-5 left-8">
                                                    {{ dashboardTranslate[language].billing.name }}  
                                                </span>
                                                <input 
                                                    type="text"
                                                    id="name"
                                                    class="border-1 border shadow w-full px-4 pt-6 pb-3 font-bold rounded-md"           
                                                    v-model="formData.name" >
                                            </label>
                                            <span v-if="formDataError.name" class="text-red-100 w-full text-xs px-4 ">
                                                    {{ dashboardTranslate[language].billing.name }}   {{formDataError.name}}
                                            </span>
                                            <label for="rfc" class="px-4 pt-3 top-0 text-sm font-medium flex items-center relative">
                                                <span class="text-green-500 opacity-50 w-full absolute top-5 left-8">
                                                    RFC 
                                                </span>
                                                <input
                                                    type="text"
                                                    id="rfc"
                                                    class="border-1 border shadow w-full px-4 pt-6 pb-3 font-bold rounded-md"
                                                    v-model="formData.rfc" maxlength="13">
                                            </label>
                                             <span v-show="formDataError.rfc" class="text-red-100 w-full text-xs px-4 ">
                                                    RFC {{formDataError.rfc}}
                                            </span>
                                             <label for="tipoDetarjeta" class="px-4 pt-3 top-0 text-sm font-medium flex items-center relative">
                                                <span class="text-green-500 opacity-50 w-full absolute top-5 left-8 z-10">
                                                    {{ dashboardTranslate[language].billing.cardType }}  
                                                </span>
                                                <div class="select-wrapper">
                                                    <FontAwesomeIcon :icon="faCaretDown" class="icon"/>
                                                    <select 
                                                        type="text"
                                                        id="tipoDetarjeta " 
                                                        class="border-1 border shadow w-full px-4 pt-6 pb-3 font-bold rounded-md"
                                                        v-model="formData.cardType">
                                                            <option value=""> {{ dashboardTranslate[language].billing.cardType }}   </option> 
                                                            <option :value="item.code" v-for="item in cardTypeCode" :key="item.code">{{ item.description}} </option>
                                                    </select>
                                                </div>
                                            </label>
                                             <span v-show="formDataError.cardType" class="text-red-100 w-full text-xs px-4 ">
                                                     {{ dashboardTranslate[language].billing.cardType }} {{formDataError.cardType}}
                                            </span>
                                            <label for="clave" class="px-4 pt-3 top-0 text-sm font-medium flex items-center relative">
                                                <span class="text-green-500 opacity-50 w-full absolute top-5 left-8 z-10">
                                                    {{ dashboardTranslate[language].billing.clave }}
                                                </span>
                                                    <div class="select-wrapper">
                                                    <FontAwesomeIcon :icon="faCaretDown" class="icon"/>
                                                        <select 
                                                            type="text"
                                                            id="clave"
                                                            class="border-1 border shadow w-full px-4 pt-6 pb-3 font-bold rounded-md"
                                                            v-model="formData.clave">
                                                                <option :value="item.code" v-for="item in cFDICode" :key="item.code">{{ item.description}} </option>
                                                        </select>
                                                    </div>
                                            </label>
                                            <label for="zipcode" class="px-4 pt-3 top-0 text-sm font-medium flex items-center relative">
                                                <span class="text-green-500 opacity-50 w-full absolute top-5 left-8 z-10">
                                                    {{ dashboardTranslate[language].billing.zipCode }}  
                                                </span>
                                                <input
                                                    type="text" pattern="^[0-9]*$"
                                                    maxlength="5"
                                                    id="zipcode"
                                                    class="border-1 border shadow w-full px-4 pt-6 pb-3 font-bold rounded-md"
                                                    v-model="formData.zipCode"
                                                    v-maska="'#####'">
                                            </label>
                                             <span v-show="formDataError.zipCode" class="text-red-100 w-full text-xs px-4 ">
                                                    {{ dashboardTranslate[language].billing.zipCode }}   {{formDataError.zipCode}}
                                            </span>
                                             <label for="clave" class="px-4 pt-3 top-0 text-sm font-medium flex items-center relative">
                                                <span class="text-green-500 opacity-50 w-full absolute top-5 left-8 z-10">
                                                     {{ dashboardTranslate[language].billing.regimen }}
                                                </span>
                                                    <div class="select-wrapper">
                                                    <FontAwesomeIcon :icon="faCaretDown" class="icon"/>
                                                        <select 
                                                            type="text"
                                                            id="regimenCode"
                                                            class="border-1 border shadow w-full px-4 pt-6 pb-3 font-bold rounded-md"
                                                            v-model="formData.regimenCode">
                                                            <option value="" >  {{ dashboardTranslate[language].billing.select }}  {{ dashboardTranslate[language].billing.regimen }}  </option>
                                                            <option :value="item.code" v-for="item in regimenCode" :key="item.code"> {{item.code }} - {{ item.description}} </option>
                                                        </select>
                                                    </div>
                                            </label>
                                             <span v-show="formDataError.clave" class="text-red-100 w-full text-xs px-4 ">
                                                    {{ dashboardTranslate[language].billing.regimen }}  {{formDataError.clave}}
                                            </span>
                                                <div class="px-4 mt-5">
                                                    <button class="w-full flex items-center justify-center px-12 py-3 font-bold rounded-xl text-white bg-green-150  border-2 border-white hover:bg-green-400" @click.prevent="onSubmit">
                                                        {{ dashboardTranslate[language].billing.save }}  
                                                    </button>
                                                </div>
                                                <div class="px-4 mt-5 flex items-center justify-center">
                                                    <button type="button" class="py-3 px-5 border-b-4 font-bold text-green-500  text-center hover:border-green-200 hover:text-green-200 xs:mx-2" @click="isEditFacturacion = false">
                                                    {{ dashboardTranslate[language].billing.cancel }}  
                                                </button>
                                             </div>
                                        </form>
                                    </div>
                                </div>
                                <div class="box w-full lg:w-1/2 flex flex-col justify-between px-6 pt-6 pb-8 mb-5 lg:mb-0">
                                    <Notification
                                        type="error"
                                        :title="`<strong> ${notificationTranslate[language][enitnaError.code].title}</strong>
                                                <span class='font-light'> ${notificationTranslate[language][enitnaError.code].content}</span>`"
                                        v-if="isEnitmaError"
                                        />
                                    <div class="pb-5 lg:pb-0" v-if="paginatedInvoice">
                                        <h3 class="section-header text-2xl text-green-500 font-semibold md:font-bold mb-5">{{ dashboardTranslate[language].card.payment.paymentHistoryTitle}}</h3>
                                        <div v-if="paginatedInvoice.items.length == 0" class="text-center"> 
                                            {{ dashboardTranslate[language].card.payment.noInvoice}}
                                            No invoice records found</div>
                                        <div class="flex border-b py-2" v-for="i in paginatedInvoice.items" :key="i">
                                            <div class="w-2/3 pr-2">
                                                <p class="text-gray-300 text-sm">{{i.description }}</p>
                                                <div class="flex mt-3">
                                                     <img src="@/assets/img/cc/mastercard.svg" width="50" v-if="i.cardType == 'Mastercard' "/>
                                                    <img src="@/assets/img/cc/amex.svg" width="50" v-if="i.cardType == 'Amex' "/>
                                                    <img src="@/assets/img/cc/visa.svg" width="50" v-if="i.cardType == 'Visa' "/>
                                                    <p class="text-green-500 font-semibold ml-3 "> &middot; &middot; &middot; {{i.number}} </p>
                                                </div>
                                            </div>
                                             <div class="w-2/4 ">
                                                <div class="flex items-right justify-end  mt-4 w-full text-right">
                                                    <p class=" text-green-500 font-semibold  w-full "> ${{i.netTotalAmount}} {{currency}} </p>
                                                </div>
                                                <div class=" w-full text-right">
                                                    <a href="#" @click.prevent="onCheckFacturar(i)"  :class="{ 'text-gray-400' : subscription?.billing.fiscals == null, 'cursor-not-allowed' : subscription?.billing.fiscals == null}" > 
                                                        <FontAwesomeIcon
                                                            :icon="faFileInvoiceDollar"
                                                            class="hover:cursor-pointer cursor-pointer text-xs mr-1 "
                                                            v-if="i.isInvoiced == false && i.isBillable == true" />
                                                        <FontAwesomeIcon 
                                                            :icon="faDownload"
                                                            class="hover:cursor-pointer cursor-pointer text-xs mr-1"
                                                            v-if="i.isInvoiced == true && i.isBillable == false" />
                                                        <span class="text-xs" v-if="i.isBillable == false  && i.isInvoiced == true ">
                                                            {{ dashboardTranslate[language].billing.downloadInvoice}}
                                                        </span>
                                                        <span class="text-xs" v-if="i.isInvoiced == false && i.isBillable == true" >
                                                            {{ dashboardTranslate[language].billing.requestInvoice}}
                                                        </span>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div> 
                                    <div class="flex my-5 justify-end" v-if="paginatedInvoice" v-show="paginatedInvoice.totalPages > 1">
                                        <button class="bg-gray-300 rounded-full w-10 h-10"
                                            @click="paginateInvoice( paginatedInvoice.currentPage - 1 , 5 ) "
                                            :disabled="paginatedInvoice.currentPage == 1"
                                            :class="{'cursor-not-allowed' : paginatedInvoice.currentPage == 1,
                                                    'bg-gray-300' : paginatedInvoice.currentPage == 1,
                                                    'bg-black' : paginatedInvoice.currentPage != 1 }">
                                            <FontAwesomeIcon :icon="faArrowLeft" class="text-white"/>
                                        </button>
                                        <div class="flex h-10 items-center w-1/3 px-5 justify-center ">
                                            <a href="#" 
                                               class="mx-auto"
                                               v-for="i in paginatedInvoice.totalPages" 
                                               :class="{'font-semibold' : paginatedInvoice.currentPage == i }"
                                               :key="i"
                                               @click="paginateInvoice( i, 5 )">
                                               {{i}}
                                            </a>
                                        </div>
                                        <button class=" rounded-full w-10 h-10"
                                            @click="paginateInvoice( paginatedInvoice.currentPage + 1 , 2 )"
                                            :disabled="paginatedInvoice.currentPage == paginatedInvoice.totalPages"
                                            :class="{'cursor-not-allowed' : paginatedInvoice.currentPage == paginatedInvoice.totalPages,
                                                    'bg-gray-300' : paginatedInvoice.currentPage == paginatedInvoice.totalPages,
                                                    'bg-black' : paginatedInvoice.currentPage != paginatedInvoice.totalPages }">
                                             <FontAwesomeIcon :icon="faArrowRight" class="text-white"/>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section class="my-5">
                        <div class="text-center p-10">
                            <div>{{dashboardTranslate[language].information.text }} </div>
                            <div><a :href="`mailto:${dashboardTranslate[language].information.email}`" class="text-green-400 font-semibold">{{dashboardTranslate[language].information.email }} </a></div>
                        </div>
                    </section>
                </div>
            </div>
        </main>
    <FooterCheckout />
    </div>
</template>
<script>

    import HeaderDashboard from "@/components/header/Header.vue"
    import FooterCheckout from "@/components/Footer.vue"
    import DashboardSidebarMenu from "@/components/dashboard/SidebarMenu.vue"
    import VivaLoader from "@/components/loader/Loader.vue"
    import DashboardUserCardInformation from '@/components/dashboard/UserCardInformation.vue'
    import Notification from "@/components/notifications/Notification.vue"
    import { notificationTranslate } from '@/translations/Notifications.js'

    import { computed, ref } from "@vue/reactivity"
    import { useStore } from "vuex"
    import { onMounted, watch } from "@vue/runtime-core"
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
    import { faEdit, faDownload, faArrowLeft, faArrowRight, faCaretDown, faFileInvoiceDollar} from '@fortawesome/free-solid-svg-icons'
    import { dashboardTranslate } from '@/translations/Dashboard.js'
    import { dataLayerViewCard, dataLayerEditCard,dataLayerDownloadInvoice } from '@/pixels/datalayer.js'
    import { useRouter } from "vue-router"
    import { maska } from 'maska'

    export default ({
        name: 'Perfil',
        components: {
            HeaderDashboard,
            FooterCheckout,
            DashboardSidebarMenu,
            VivaLoader,
            Notification,
            DashboardUserCardInformation,
            FontAwesomeIcon
        },
        directives: { maska },
        setup(){
            const store = useStore()
            const router = useRouter()
            const isEditFacturacion  = ref(false)
            const linkPdf = ref('')
            const formData =  ref({
                name: null,
                rfc: null,
                cardType: null,
                clave : null,
                regimenCode: "",
                zipCode: '',
            })
            const enitnaError = computed(() => {
                return store.state.Accounts.error.enitma
            })
            const isEnitmaError = computed(() => {
                return store.state.Accounts.isError.enitma
            })
            const cFDICode = ref([
                {
                    code: 'G01',
                    description: 'Adquisición de mercancías.'
                },
                {
                    code: 'G02',
                    description: 'Devoluciones, descuentos o bonificaciones.'
                },
                {
                    code: 'G03',
                    description: 'Gastos en general.'
                },
                {
                    code: 'I01',
                    description: 'Construcciones.'
                },
                {
                    code: 'I02',
                    description: 'Mobiliario y equipo de oficina por inversiones.'
                },
                {
                    code: 'I03',
                    description: 'Equipo de transporte.'
                },
                {
                    code: 'I04',
                    description: 'Equipo de computo y accesorios.'
                },
                {
                    code: 'I05',
                    description: 'Dados, troqueles, moldes, matrices y herramental.'
                },
                {
                    code: 'I06',
                    description: 'Comunicaciones telefónicas.'
                },
                {
                    code: 'I07',
                    description: 'Comunicaciones satelitales.'
                },
                {
                    code: 'I08',
                    description: 'Otra maquinaria y equipo.'
                },
                {
                    code: 'D01',
                    description: 'Honorarios médicos, dentales y gastos hospitalarios.'
                },
                {
                    code: 'D02',
                    description: 'Gastos médicos por incapacidad o discapacidad.'
                },
                {
                    code: 'D03',
                    description: 'Gastos funerales.'
                },
                {
                    code: 'D04',
                    description: 'Donativos.'
                },
                {
                    code: 'D05',
                    description: 'Intereses reales efectivamente pagados por créditos hipotecarios (casa habitación).'
                },
                {
                    code: 'D06',
                    description: 'Aportaciones voluntarias al SAR.'
                },
                {
                    code: 'D07',
                    description: 'Primas por seguros de gastos médicos.'
                },
                {
                    code: 'D08',
                    description: 'Gastos de transportación escolar obligatoria.'
                },
                {
                    code: 'D09',
                    description: 'Depósitos en cuentas para el ahorro, primas que tengan como base planes de pensiones.'
                },
                {
                    code: 'D10',
                    description: 'Pagos por servicios educativos (colegiaturas).'
                },
                {
                    code: 'S01',
                    description: 'Sin efectos fiscales. '
                },
                {
                    code: 'CP01',
                    description: 'Pagos'
                },
                {
                    code: 'CN01',
                    description: 'Nómina'
                },
                
            ])
            const cardTypeCode = ref([
                {
                    code: '04',
                    description: 'Tarjeta de crédito'
                },
                {
                    code: '28',
                    description: 'Tarjeta de débito'
                },
            ])
            const regimenCode = ref([
                {
                    code: '601',
                    description: 'General de Ley Personas Morales'
                },
                {
                    code: '603',
                    description: 'Personas Morales con Fines no Lucrativos'
                },
                {
                    code: '605',
                    description: 'Sueldos y Salarios e Ingresos Asimilados a Salarios'
                },
                {
                    code: '606',
                    description: 'Arrendamiento'
                },
                {
                    code: '607',
                    description: 'Régimen de Enajenación o Adquisición de Bienes'
                },
                {
                    code: '608',
                    description: 'Demás ingresos'
                },
                {
                    code: '610',
                    description: 'Residentes en el Extranjero sin Establecimiento Permanente en México'
                },
                {
                    code: '611',
                    description: 'Ingresos por Dividendos (socios y accionistas)'
                },
                {
                    code: '612',
                    description: 'Personas Físicas con Actividades Empresariales y Profesionales'
                },
                {
                    code: '614',
                    description: 'Ingresos por intereses'
                },
                {
                    code: '615',
                    description: 'Régimen de los ingresos por obtención de premios'
                },
                {
                    code: '616',
                    description: 'Sin obligaciones fiscales'
                },
                {
                    code: '620',
                    description: 'Sociedades Cooperativas de Producción que optan por diferir sus ingresos'
                },
                  {
                    code: '621',
                    description: 'Incorporación Fiscal'
                },
                {
                    code: '622',
                    description: 'Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras'
                },
                {
                    code: '623',
                    description: 'Opcional para Grupos de Sociedades'
                },
                {
                    code: '624',
                    description: 'Coordinados'
                },
                 {
                    code: '625',
                    description: 'Régimen de las Actividades Empresariales con ingresos a través de Plataformas Tecnológicas'
                },
                {
                    code: '626',
                    description: 'Régimen Simplificado de Confianza'
                },

            ])

            const fracturacionError = computed( () =>{
                return store.state.Checkout.error.facturacion
            })
            const fracturacionSuccess = computed( () =>{
                return store.state.Checkout.isSuccess.facturacion
            })
            
            const formDataError = ref({})
            const paginatedInvoice = ref({ items : [] })
            const account = computed( () =>{
                return store.state.Accounts.data
            })
            const subscription = computed( () =>{

                return store.state.Checkout.data.userSubscription.data
            })
            const language = computed( ()=> {
                return localStorage.getItem('viva-translate') ? localStorage.getItem('viva-translate') : 'es';
            })
           
            const formatExpirationDate = ( date ) =>{
                const expire = new Date(date)
                const options = { year: 'numeric', month: 'long', day: 'numeric' };
                const lang = language.value  == 'es' ? 'es-ES' : 'en-US'

                return expire.toLocaleDateString(lang, options)
            }
            const formatInvoiceDate = ( date ) =>{
                const expire = new Date(date)
                const options = { year: 'numeric', month: 'short', day: 'numeric',  timeZone: "UTC"  };

                const lang = language.value  == 'es' ? 'es-ES' : 'en-US'
                return expire.toLocaleDateString(lang, options)
            }
            const generateHTMLErrorList = ( params ) => {
                if( Object.keys(fracturacionError.value).length > 0 ){
                    const list = params.map( index => (`<li>${index.message} </li> `))
                    const html = `<ul> ${list} </ul>`
                    return html
                } else {
                      return ''
                }
            }

            const generateInvoicePDF = async ( data ) => {
                dataLayerDownloadInvoice()
                await store.dispatch('generateInvoicePDF', { id : data.id , dateName :  data.date.replace(/ /g,'-') })
            }

            const goToLink = ( routerName ) =>{
                dataLayerEditCard()
                router.push({name:routerName})
                
            }
            
            const getRegimenCodeDescription = ( code ) => {

                const codeItem  = regimenCode.value.find( item  => item.code == code )
                if( codeItem ){
                    return `${codeItem.code} - ${codeItem.description}`
                } else { 
                    return ''
                }
            }

            const getPaymentCodeDescription =  ( code ) => {

                const codeItem  = cardTypeCode.value.find( item  => item.code == code )
                if( codeItem ){
                    return `${codeItem.description}`
                } else { 
                    return ''
                }
            }

             const getCFDIUseDescription = ( code ) => {

                const codeItem  = cFDICode.value.find( item  => item.code == code )
                if( codeItem ){
                    return `${codeItem.description}`
                } else { 
                    return ''
                }
            }

            const paginateInvoice = ( page, perPage ) =>{
                const items = subscription.value.billing.invoices
                const offset = perPage * (page - 1);
                const totalPages = Math.ceil(items.length / perPage);
                const paginatedItems = items.slice(offset, perPage * page);
                
                paginatedInvoice.value = {
                    previousPage: page - 1 ? page - 1 : null,
                    nextPage: (totalPages > page) ? page + 1 : null,
                    total: items.length,
                    totalPages: totalPages,
                    items: paginatedItems,
                    currentPage : page
                };
            }

            const currency = computed(() => {
                return  localStorage.getItem('viva-currency') ? localStorage.getItem('viva-currency') : 'MXN';
            })

            const initDataLayerCardView = () => {
                dataLayerViewCard( 'payment method' )
                dataLayerViewCard( 'payment history' )
            }

            const onSubmit = async () => {
               
                Object.keys(formData.value).map( (x) => {
                    if( !formData.value[x])
                        formDataError.value[x] = dashboardTranslate[language.value].billing.isRequired 
                    else
                        if( formDataError.value[x] )
                            delete formDataError.value[x]
                })

                if( Object.keys(formDataError.value).length == 0 ){
                    const data = { method: subscription.value.billing.fiscals ==  null ? 'post' : 'put', 
                                    data : { 
                                        id: subscription.value.customer.customerNumber,
                                        rfc: formData.value.rfc.toUpperCase(),
                                        cfdiUse: formData.value.clave,
                                        bussinessName: formData.value.name,
                                        paymentCode: formData.value.cardType,
                                        regimenCode: formData.value.regimenCode,
                                        zipCode: formData.value.zipCode,
                                    }
                                }
                    
                    await store.dispatch( 'onSendBilling', data)

                    isEditFacturacion.value = fracturacionError.value.length > 0 ? true : false

                    await store.dispatch('getSubscription', { plan: 'vfn'})
                    
                }   
            }

            const onCheckFacturar = async ( item ) =>{
                
                if( !subscription.value.billing.fiscals ) {
                    return 
                }

               const fiscals = subscription.value.billing?.fiscals[0]
                
                if( item.isBillable == true && item.isInvoiced == false ) {
                   await store.dispatch('getEnitmaToken')
                
                    const params  = {
                        "RFC" : fiscals.rfc,
                        "IdInvoice" : item.id ,
                        "CdgFormaPago": fiscals.paymentCode,
                        "CdgUsoCFDI": fiscals.cfdiUse,
                        "RazonSocial": fiscals.bussinessName,
                        "CodigoPostal":  fiscals.zipCode,
                        "RegimenFiscal": fiscals.regimenCode
                    }
                    await store.dispatch('requestEnitmaInvoice', params )
                    await store.dispatch('getSubscription', { plan: 'vfn'})
                    await store.dispatch('getSubscriptionInvoice', { plan: 'vfn', currency: currency.value })
                    paginateInvoice(1, 5 )

                }
                 if( item.isBillable == false && item.isInvoiced == true ) {
                         if( item.linkPDF ){
                            const b = document.createElement('a');
                            b.setAttribute('class', 'download-pdf')
                            b.setAttribute('href', item.linkPDF);
                            b.setAttribute('target', '_blank');
                            b.setAttribute('download', `Viva-invoice-${item.id}.pdf`);
                            setTimeout( ()=> {
                                 b.click()
                            }, 1000 )
                        }
                        if( item.linkXML ){
                            const a = document.createElement('a');
                            a.setAttribute('class', 'download-pdf')
                            a.setAttribute('href', item.linkXML);
                            a.setAttribute('target', '_blank');
                            a.setAttribute('download', `Viva-invoice-${item.id}.pdf`);

                            a.dataset.downloadurl = ["text/plain", a.download, a.href].join(":");
                            a.draggable = true;
                            a.classList.add("dragout");
                            a.click();
                        }
                        
                }
            }

            watch( subscription , ( value )  => {
                 
            formData.value = {
                    name: value.billing.fiscals != null ? value.billing.fiscals[0].bussinessName : null,
                    rfc: value.billing.fiscals != null ? value.billing.fiscals[0].rfc : null,
                    cardType: value.billing.fiscals != null ? value.billing.fiscals[0].paymentCode : null,
                    clave : value.billing.fiscals != null ? value.billing.fiscals[0]?.cfdiUse : null,
                    regimenCode: value.billing.fiscals != null ? value.billing.fiscals[0].regimenCode : null,
                    zipCode: value.billing.fiscals != null ? value.billing.fiscals[0].zipCode : null,
                }
            })
            onMounted( async ()=> {
                if( Object.keys(store.state.Accounts.data).length == 0 ){
                    await store.dispatch('checkAccount')
                }
                
                await store.dispatch('getSubscriptionInvoice', { plan: 'vfn', currency: currency.value })
                    paginateInvoice(1, 5 )
                    initDataLayerCardView()
                
            })

            return { account, faEdit, faDownload, faArrowLeft, faArrowRight, faCaretDown, subscription, paginatedInvoice, dashboardTranslate, language, currency, fracturacionError,
            isEditFacturacion, faFileInvoiceDollar, formData, goToLink, onSubmit, formDataError, formatExpirationDate, formatInvoiceDate,  paginateInvoice, generateInvoicePDF, generateHTMLErrorList, regimenCode, fracturacionSuccess,getRegimenCodeDescription, getCFDIUseDescription, getPaymentCodeDescription,  cardTypeCode, cFDICode, onCheckFacturar, isEnitmaError, enitnaError, linkPdf, notificationTranslate} 
        },
    
    })
</script>

<style scoped>
.box {
    @apply bg-white border border-gray-200 shadow rounded-lg text-left rounded-lg shadow overflow-hidden;
}
h5 {
    @apply md:text-sm text-green-400;
    font-size: 0.75rem;
}
input.form-control, select.form-control{
    @apply font-semibold text-left focus:ring-green-400 focus:border-green-400 block w-full text-18 border-gray-300 rounded-md pt-7 pb-2 px-4 rounded-xl shadow-sm border text-green-500 outline-none;
}
label > span {
    @apply text-green-500 sm:text-xs;
}
.form-check-radio {
    @apply w-5 h-5 border-2 rounded-full bg-blue-100;
}
.form-radio-wrapper {
    @apply flex content-center items-center pt-5 pb-0 md:py-5 w-full md:w-auto;
}
.disabled {
    @apply opacity-50 cursor-not-allowed
}

select {
    -webkit-appearance: none;
  appearance: none;
}
.select-wrapper {
  @apply w-full;
  position: relative;
  z-index: 0;
}

.select-wrapper .icon{
  content: "▼";
  font-size: 1rem;
  top: 16px;
  right: 16px;
  position: absolute;
}

.fade-enter-from {
    opacity: 0;
    height: 0;
}
.fade-enter-to {
    opacity: 1;
    height: auto;
}
.fade-enter-active {
   transition: all 300ms ease-out;
}
.fade-leave-from {
    opacity: 1;
    height: auto;
}
.fade-leave-to {
    opacity: 0;
    height: 0;
}
.fade-leave-active {
   transition: all 300ms ease-out;
}
</style>